const DIRECT_HOLD_FIELDS = ["hold_seconds", "hold", "hold_time", "duration"];
const TEXT_HOLD_FIELDS = [
  "goal",
  "notes",
  "instructions_override",
  "instructions",
  "description",
  "frequency",
  "Suggested Dosage",
  "Goal / Progression",
  "Instructions Placeholder",
];

function positiveWholeSeconds(value) {
  const number = Number(value);
  if (!Number.isFinite(number) || number <= 0) return null;
  return Math.min(3600, Math.round(number));
}

export function parseDurationSeconds(value, allowBareNumber = false) {
  if (typeof value === "number") return positiveWholeSeconds(value);
  if (typeof value !== "string") return null;

  const text = value.trim().toLowerCase();
  if (!text) return null;

  const clock = text.match(/\b(\d{1,2}):(\d{2})\b/);
  if (clock) return positiveWholeSeconds(Number(clock[1]) * 60 + Number(clock[2]));

  const minutes = text.match(/\b(\d+(?:\.\d+)?)\s*(?:minutes?|mins?|min)\b/);
  if (minutes) return positiveWholeSeconds(Number(minutes[1]) * 60);

  const seconds = text.match(/\b(\d+(?:\.\d+)?)\s*(?:seconds?|secs?|sec|s)\b/);
  if (seconds) return positiveWholeSeconds(seconds[1]);

  const holdNumber = text.match(/\bhold(?:\s+for)?\s+(\d+)\b/);
  if (holdNumber) return positiveWholeSeconds(holdNumber[1]);

  if (allowBareNumber && /^\d+(?:\.\d+)?$/.test(text)) return positiveWholeSeconds(text);
  return null;
}

function findHoldIn(exercise) {
  if (!exercise || typeof exercise !== "object") return null;

  for (const field of DIRECT_HOLD_FIELDS) {
    const seconds = parseDurationSeconds(exercise[field], true);
    if (seconds) return seconds;
  }

  for (const field of TEXT_HOLD_FIELDS) {
    const seconds = parseDurationSeconds(exercise[field]);
    if (seconds) return seconds;
  }

  return null;
}

export function getSmartHoldSeconds(assignedExercise) {
  if (!assignedExercise || typeof assignedExercise !== "object") return null;
  return findHoldIn(assignedExercise) || findHoldIn(assignedExercise.exercise);
}

export function parseExerciseCount(value) {
  if (typeof value === "number") return Number.isInteger(value) && value > 0 ? Math.min(value, 99) : null;
  if (typeof value !== "string") return null;
  const match = value.trim().match(/\d+/);
  if (!match) return null;
  const count = Number(match[0]);
  return count > 0 ? Math.min(count, 99) : null;
}

function findCount(assignedExercise, field) {
  return parseExerciseCount(assignedExercise?.[field]) || parseExerciseCount(assignedExercise?.exercise?.[field]);
}

export function getExerciseCounts(assignedExercise) {
  return {
    reps: findCount(assignedExercise, "reps"),
    sets: findCount(assignedExercise, "sets"),
  };
}

export function formatTimer(seconds) {
  const safeSeconds = Math.max(0, Math.round(Number(seconds) || 0));
  const minutes = Math.floor(safeSeconds / 60);
  return `${String(minutes).padStart(2, "0")}:${String(safeSeconds % 60).padStart(2, "0")}`;
}
